export default "__VITE_ASSET__BhA46tR9__"